import * as b from "react";
import { i as p, E as v, x as n, a as d, r as m, c as u } from "../createReactComponent-58f9bea8.mjs";
import { n as e } from "../property-9daa16cd.mjs";
import { e as x } from "../class-map-2994e95e.mjs";
import { p as h } from "../helpers-770f41c9.mjs";
import { r as f } from "../icon-c572aa57.mjs";
const y = p`
  :host {
    --exo-width-small: 40px;
    --exo-height-small: 20px;
    --exo-width-large: 48px;
    --exo-height-large: 24px;
    --exo-component-toggle-label-gap: 2px;
  }

  :host(:focus-visible) {
    outline: none;
  }

  :host .toggle--container {
    display: flex;
    align-items: center;
    gap: var(--exo-spacing-x-small);
    position: relative;
    border-radius: var(--exo-spacing-2x-small);
    border: var(--exo-spacing-3x-small) solid transparent;
    transition: border var(--exo-time-standard) ease;
  }

  :host .toggle--container input {
    position: absolute;
    opacity: var(--exo-opacity-0);
  }

  :host .toggle--indicator-lane {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: var(--exo-radius-x-large);
    padding: var(--exo-spacing-2x-small);
    gap: var(--exo-spacing-x-small);
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    background: var(--exo-color-background-action-secondary);
    justify-content: space-around;
    position: relative;
    transition:
      background var(--exo-time-standard) ease,
      color var(--exo-time-standard) ease;
    cursor: pointer;
    font-size: var(--exo-font-size-micro);
    color: var(--exo-color-background);
    box-sizing: border-box;
  }

  :host .toggle--indicator {
    background: var(--exo-color-background-deselected);
    flex-grow: var(--exo-spacing-none);
    border-radius: var(--exo-radius-x-large);
    position: absolute;
    left: 8%;
    transition:
      left var(--exo-time-standard) ease,
      background var(--exo-time-standard) ease;
    z-index: 1;
  }

  :host .on .toggle--indicator-lane {
    background: var(--exo-color-background-selected);
    border: none;
  }

  :host .toggle--indicator-lane ex-icon {
    color: var(--exo-color-background-deselected);
  }

  :host .toggle--indicator-lane ex-icon::part(icon) {
    width: 1em;
    height: 1em;
  }

  :host .toggle--label {
    cursor: pointer;
    display: flex;
    user-select: none;
    color: var(--exo-color-font);
    font: var(--exo-text-label-micro);
    align-items: center;
    gap: var(--exo-component-toggle-label-gap);
  }

  /**** hover ****/
  :host .toggle--container:not(.disabled):focus-visible .toggle--indicator-lane,
  :host .toggle--indicator-lane:hover {
    background: var(--exo-color-background-action-hover-weak);
    border: var(--exo-spacing-4x-small) solid
      var(--exo-color-background-action-hover);
  }
  :host
    .toggle--container.on:not(.disabled):focus-visible
    .on
    .toggle--indicator-lane,
  :host .on .toggle--indicator-lane:hover {
    background: var(--exo-color-background-selected-hover);
    border: none;
  }

  /**** Focus ****/

  :host .toggle--container:not(.disabled):focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-action-hover);
  }

  :host .toggle--container.on:not(.disabled):focus-visible {
    outline: var(--exo-spacing-3x-small) solid
      var(--exo-color-background-selected);
  }

  /**** Disabled ****/

  :host .disabled .toggle--indicator-lane {
    cursor: default;
    border: var(--exo-spacing-4x-small) solid var(--exo-color-border);
    background: var(--exo-color-background-action-secondary);
  }

  :host .disabled.on .toggle--indicator-lane {
    cursor: default;
    background: var(--exo-color-background-disabled);
  }

  :host .disabled .toggle--indicator {
    background: var(--exo-color-background-disabled);
  }

  :host .toggle--container.on.disabled:focus-visible,
  :host .toggle--container.disabled:focus-visible {
    outline: none;
  }

  :host .toggle--container.on.disabled .toggle--label,
  :host .toggle--container.disabled .toggle--label {
    cursor: default;
    color: var(--exo-color-font-secondary);
  }

  /**** Size ****/

  :host .toggle--container.small {
    padding: var(--exo-spacing-none) var(--exo-spacing-3x-small)
      var(--exo-spacing-none) var(--exo-spacing-2x-small);
    height: var(--exo-height-small);
  }

  :host .small .toggle--indicator-lane {
    width: var(--exo-width-small);
    height: var(--exo-height-small);
    padding: var(--exo-spacing-3x-small) var(--exo-spacing-2x-small);
    font-size: var(--exo-font-size-micro);
  }

  :host .small .toggle--indicator {
    width: var(--exo-spacing-small);
    height: var(--exo-spacing-small);
  }

  :host .small.on .toggle--indicator {
    left: 60%;
    background: var(--exo-color-background);
  }

  :host .toggle--container.large {
    padding: var(--exo-spacing-2x-small) var(--exo-spacing-3x-small)
      var(--exo-spacing-2x-small) var(--exo-spacing-2x-small);
    height: var(--exo-height-small);
  }

  :host .large .toggle--indicator-lane {
    width: var(--exo-width-large);
    height: var(--exo-height-large);
    padding: var(--exo-spacing-3x-small) var(--exo-spacing-2x-small);
    font-size: var(--exo-font-size-medium);
  }

  :host .large .toggle--indicator {
    width: var(--exo-spacing-standard);
    height: var(--exo-spacing-standard);
  }

  :host .large:not(.on) .toggle--indicator {
    left: 7%;
  }

  :host .large.on .toggle--indicator {
    left: 58.3%;
    background: var(--exo-color-background);
  }
`;
var k = Object.defineProperty, w = Object.getOwnPropertyDescriptor, t = (l, a, s, r) => {
  for (var g, i = r > 1 ? void 0 : r ? w(a, s) : a, c = l.length - 1; c >= 0; c--)
    (g = l[c]) && (i = (r ? g(a, s, i) : g(i)) || i);
  return r && i && k(a, s, i), i;
};
class o extends v {
  constructor() {
    super(), this.on = !1, this.disabled = !1, this.controlled = !1, this.showToggleLabel = !1, this.showSymbol = !0, this.toggleLabel = "", this.size = "small", this.leftIcon = "Check", this.rightIcon = "Close", this.label = "toggle", this.tabndex = 1, this.leftIconLabel = "", this.rightIconLabel = "", this.addEventListener("keyup", this.onKeyUp);
  }
  onClick() {
    this.disabled || this.controlled || (this.on = !this.on, this.dispatchEvent(new CustomEvent("onChange", { detail: this.on })));
  }
  onKeyUp(a) {
    this.disabled || this.controlled || a.key !== "Enter" || (this.on = !this.on, this.dispatchEvent(new CustomEvent("onChange", { detail: this.on })));
  }
  getToggleLabel() {
    return this.showToggleLabel ? n`<span
        class="toggle--label"
        part="toggle--label"
        @click=${this.onClick}
        >${this.toggleLabel}<slot name="header-suffix"></slot
      ></span>` : d;
  }
  getLeftIcon() {
    return this.showSymbol ? n`<ex-icon
        icon="${this.leftIcon}"
        variant="${this.disabled ? "disabled" : "inverse"}"
        label=${this.leftIconLabel}
      ></ex-icon>` : d;
  }
  getRightIcon() {
    return this.showSymbol ? n`<ex-icon
        icon="${this.rightIcon}"
        variant="${this.disabled ? "disabled" : "default"}"
        label=${this.rightIconLabel}
      ></ex-icon>` : d;
  }
  render() {
    const a = { toggle: !0, on: this.on, disabled: this.disabled, controlled: this.controlled, [this.size]: !0 };
    return n`
      <div
        class="${x({ "toggle--container": !0, disabled: this.disabled, on: this.on, [this.size]: !0 })}"
        tabindex="0"
      >
        ${this.getToggleLabel()}
        <div
          class="${x(a)}"
          aria-disabled=${this.disabled}
          aria-label=${this.label}
          aria-checked=${this.on}
          role="switch"
          @keyup=${this.onClick}
          part="toggle"
        >
          <input type="checkbox" aria-checked=${this.on} tabindex="-1" />
          <div
            class="toggle--indicator-lane"
            @click=${this.onClick}
            part="toggle ${this.on}"
          >
            ${this.getLeftIcon()}
            <div class="toggle--indicator"></div>
            ${this.getRightIcon()}
          </div>
        </div>
      </div>
    `;
  }
}
o.styles = y, t([e({ type: Boolean, converter: h.boolean })], o.prototype, "on", 2), t([e({ type: Boolean, converter: h.boolean })], o.prototype, "disabled", 2), t([e({ type: Boolean, converter: h.boolean })], o.prototype, "controlled", 2), t([e({ type: Boolean })], o.prototype, "showToggleLabel", 2), t([e({ type: Boolean })], o.prototype, "showSymbol", 2), t([e()], o.prototype, "toggleLabel", 2), t([e()], o.prototype, "size", 2), t([e()], o.prototype, "leftIcon", 2), t([e()], o.prototype, "rightIcon", 2), t([e()], o.prototype, "label", 2), t([e()], o.prototype, "tabndex", 2), t([e({ type: String })], o.prototype, "leftIconLabel", 2), t([e({ type: String })], o.prototype, "rightIconLabel", 2);
const $ = (l = "") => {
  m("ex-toggle", o, l), f(l);
}, S = u({ tagName: "ex-toggle", elementClass: o, react: b, events: { onChange: "onChange" }, displayName: "ExToggle", registerWebComponent: $ });
export {
  S as ExToggle,
  $ as register
};
